import CompanyGiftForm from './CompanyGiftForm';

export default CompanyGiftForm;

export const componentName = 'CompanyGiftForm';
